var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"app":""}},[_c('v-main',{ref:"container",staticClass:" light6"},[_c('router-view')],1),(_vm.$route.name != 'PrintApplication')?_c('ad-footer',{staticClass:"d-print-none"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }